import _ from 'lodash'

function removeHtmlTag(text) {
  if (!_.isString(text)) return text

  return text.replace(/(<([^>]+)>)/ig, '')
}

export default removeHtmlTag
